import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import 'rxjs/add/operator/share';
import { environment } from '../environments/environment';

import { catchError, map, tap } from 'rxjs/operators';
import { MyUtility } from './comparison';
import { AlertService } from './alert.service';
import { Entity } from './criterias/select-list/select-list.component';

@Injectable()
export class ApiService {

  private apiUrlBase: string;
  private reportViewerBase: string;
  private loginUrl: string;
  public isLoading: boolean;
  setIsLoading(val) {
    console.log('setting isloading to ' + val);
    this.isLoading = val;
  }

  // public disableErrorHandlingForNextRequest: boolean = false;

  private _session;
  public get session() {
    return this._session;
    // if (this._session)
    //   return this._session;
    // return this._session = JSON.parse(localStorage.getItem('session'));
  }
  public set session(session) {
    this._session = session;
    // localStorage.setItem('session', JSON.stringify(session));
  }

  constructor(private http: HttpClient, private alerter: AlertService) {
    let url = new URL(window.location.origin);
    url.port = environment.apiPort;
    this.reportViewerBase = url.toString();
    this.apiUrlBase = url.toString() + "api";
  }

  private makeApiGetRequest(controllerName, viewName, parmsObject): WebRequest {
    let url = this.getGetUrl(controllerName, viewName, parmsObject);
    //console.log('url: ' + url);
    this._currentRequest = new WebRequest(this.http.get(url, { withCredentials: true }), this);

    return this._currentRequest;
  }
  private makeApiDeleteRequest(controllerName, viewName, parmsObject): WebRequest {
    let url = this.getGetUrl(controllerName, viewName, parmsObject);
    //console.log('url: ' + url);
    this._currentRequest = new WebRequest(this.http.delete(url, { withCredentials: true }), this);
    return this._currentRequest;
  }

  private makeApiPostRequest(controllerName, viewName, payload): WebRequest {
    let url = `${this.apiUrlBase}/${controllerName}/${viewName}`;
    return this.makePostRequest(url, payload);
  }

  private makePostRequest(url, payload): WebRequest {
    // this.setIsLoading(true);
    //console.log('POST to url: ' + url + " payload: " + JSON.stringify(payload));
    let observable = this.http.post(url, payload, { withCredentials: true });

    this._currentRequest = new WebRequest(observable, this);
    return this._currentRequest;

    // this._currentRequest = observable.pipe(map(x => { this.setIsLoading(false); return x; }), catchError(error => of(this.handleError(error))));
    // return this._currentRequest;
  }

  _currentRequest: WebRequest;

  cancelCurrentRequest() {
    console.log('cancelCurrentRequest');
    if (!this._currentRequest)
      return;

    console.log('cancelling...');

    this._currentRequest.cancel();
  }


  private buildQueryParameters(parms) {
    let retval = "";
    if (parms == null)
      return retval;

    for (let key in parms) {
      if (retval.length > 0)
        retval += "&";
      retval += encodeURI(key);
      retval += "=";
      retval += encodeURI(parms[key]);
    }
    return retval;
  }

  login(username, password, twoFactorCode?): WebRequest {
	let payload: any={ username: username, password: password };
	if(twoFactorCode){
		payload.twoFactorCode = twoFactorCode
	}
    let request = this.makeApiPostRequest("Auth", "Login", payload);
	
    return request;
  }

  public sendPasswordReset(username: string): WebRequest {
    return this.makeApiGetRequest("Auth", "SendPasswordResetToken", { username: username });
  }

  public resetPassword(token: string, password: string) {
    return this.makeApiPostRequest("Auth", "ResetPassword", { token: token, password: password });
  }

  selectView(viewName): WebRequest {
    let request = this.makeApiGetRequest("Auth", "SelectView", { viewName: viewName });
    request.preSuccessFunc = data => {
      //console.log("LOGIN RESULT: " + JSON.stringify(data));
      if (data.success === true) {
        this.session = data.session;
        this.session.selectedUserView = viewName;
        this.originalCriteria = MyUtility.deepCopy(data.session.currentCriteria);
      }
    };
    return request;
  }

  private getGetUrl(controllerName, viewName, parmsObject) {
    let url = `${this.apiUrlBase}/${controllerName}/${viewName}?`;
    url += this.buildQueryParameters(parmsObject);
    return url;
  }

  public getReportExcelLink(reportId) {
    return this.getGetUrl("Reports", "DownloadExcelReport", { reportId: reportId })
  }

  public originalCriteria;

  saveCriteria(criteria, criteriaName) {
    let crit = MyUtility.prepareCriteriaForTransmitting(criteria);

    return this.makeApiPostRequest("Reports", "SaveCriteria", { criteria: crit, criteriaName: criteriaName });
  }
  deleteCriteria(criteriaId) {
    return this.makeApiGetRequest("Reports", "DeleteCriteria", { criteriaId: criteriaId });
  }
  getFullCriteria(criteriaId) {
    return this.makeApiGetRequest("Reports", "GetFullCriteria", { criteriaId: criteriaId });
  }

  public static isLoggingOut: boolean = false;

  logout(): WebRequest {
    ApiService.isLoggingOut = true;
    let retval = this.makeApiGetRequest("Auth", "Logout", {});
    retval.preSuccessFunc = x => { this.session = null; };
    retval.showErrorMessages = false;
    return retval;
  }

  public getAllUsers(): WebRequest {
    return this.makeApiGetRequest("Users", "Get", {});
  }

  public deleteUser(userId): WebRequest {
    return this.makeApiGetRequest("Users", "Delete", { id: userId });
  }

  public createUser(user): WebRequest {
    return this.makeApiPostRequest("Users", "Create", user);

  }
  public updateUser(user): WebRequest {
    return this.makeApiPostRequest("Users", "Update", user);
  }

  public getClients(): WebRequest {
    return this.makeApiGetRequest("Users", "GetClients", {});
  }


  prepareReport(userView: string): WebRequest {
    let crit = MyUtility.prepareCriteriaForTransmitting(this.session.currentCriteria);
    crit.userView = userView;
    let retval = this.makeApiPostRequest("Reports", "Prepare", crit);
    retval.mapper = x => this.getFullUrl(x.reportUrl);
    return retval;
  }

  keepAlive(): WebRequest {
    let retval = this.makeApiGetRequest("Auth", "KeepAlive", { r: Math.random() });
    return retval;
  }

  private getFullUrl(reportUrl) {
    console.log('in: ' + reportUrl);
    if (!reportUrl) {
      console.log('returning null');
      return null;
    }

    let retval = this.reportViewerBase + reportUrl;
    console.log("out: " + retval);
    return retval;
  }

  public handleError(err, alertUser: boolean = true) {
    console.log("ERROR: ", err);
    console.log("alertUser", alertUser);
    if (alertUser)
      this.alerter.alertError(err);

    return { success: false, err: err };
  }

  public getFrontPageMessages() {
    return this.makeApiGetRequest("FrontPageMessages", "List", {});
  }

  public getUserActivity() {
    return this.makeApiGetRequest("Users", "GetUserActivity", {});
  }

  public getSchemaAssignments() {
    return this.makeApiGetRequest("Users", "GetSchemaAssignments", {});
  }

  // private handleError(operation = 'operation', result?) {
  //   return (error: any): Observable<any> => {

  //     // TODO: send the error to remote logging infrastructure
  //     console.error(error); // log to console instead

  //     // // TODO: better job of transforming error for user consumption
  //     // this.log(`${operation} failed: ${error.message}`);

  //     console.log(JSON.stringify(error));
  //     // Let the app keep running by returning an empty result.
  //     return of({ success: false, reason: error.statusText });
  //   };
  // }
}

export class WebRequest {
  public isCancelled: boolean;
  public successFunc: any = () => { };
  public errorFunc: any = () => { };
  public mapper = x => x;
  public setIsLoading = true;
  public showErrorMessages = true;
  public ignoreErrors: boolean;
  public doneFunc: any = () => { };
  public preSuccessFunc: any = () => { };

  constructor(public observable: Observable<Object>, private api: ApiService) {
  }

  start() {
    if (this.setIsLoading)
      this.api.setIsLoading(true);

    this.observable.pipe(map(x => {
      console.log("Returned from client", x);

      if (this.isCancelled)
        return x;

      if (this.setIsLoading)
        this.api.setIsLoading(false);
      this.preSuccessFunc(x);
      x = this.mapper(x);

      this.doneFunc();
      ApiService.isLoggingOut = false;
      this.successFunc(x);
      return x;
    }), catchError(error => of(() => {
      console.log("Raw error from client request: " + JSON.stringify(error));
      if (this.isCancelled || this.ignoreErrors)
        return null;

      if (this.setIsLoading)
        this.api.setIsLoading(false);

      let retval = this.api.handleError(error, this.showErrorMessages);

      if (this.errorFunc)
        this.errorFunc(error);

      this.doneFunc();
      ApiService.isLoggingOut = false;

      return retval;
    })
    ))
      .subscribe(data => { });
  }


  public cancel() {
    if (this.setIsLoading)
      this.api.isLoading = false;

    this.successFunc = x => { };
    this.errorFunc = x => { };
  }

}
